import api from '@/services/api'
import type { ApiKeysResponse, ApiKeyType, ApiKeyUpdate } from './types'

export const ApiKeysV2Service = {
  fetchApiKeys() {
    return api.get<ApiKeysResponse>('/v2/api-keys/')
  },
  saveApiKey(exchange: string, profileNum: number, apiKeyType: ApiKeyType, data: ApiKeyUpdate) {
    return api.put(`/v2/api-keys/${apiKeyType}/${exchange}/${profileNum}`, data)
  },
  setDuplicate(
    exchange: string,
    profileNum: number,
    apiKeyType: ApiKeyType,
    duplicateId: number | null,
  ) {
    return api.put(`/v2/api-keys/${apiKeyType}/${exchange}/${profileNum}/duplicate`, {
      duplicate_id: duplicateId,
    })
  },
  deleteApiKey(exchange: string, profileNum: number, apiKeyType: ApiKeyType) {
    return api.delete(`/v2/api-keys/${apiKeyType}/${exchange}/${profileNum}`)
  },
}
